import { ExportColumn } from '../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: 'Process Area/Process',
    type: 'text',
  },
  {
    key: 'replacementTime',
    header: 'Replacement Time (months)',
    type: 'number',
  },
  {
    key: 'strategy.grossRevenueExposure',
    header: 'Total Revenue Exposure',
    type: 'money',
  },
  {
    key: 'strategy.mitigation',
    header: 'Mitigation',
    type: 'money',
  },
  {
    key: 'strategy.netRevenueExposure',
    header: 'Residual Revenue Exposure',
    type: 'money',
  },
  {
    key: 'strategy.strategyAge',
    header: 'Strategy Age',
    type: 'number',
  },
  {
    key: 'strategy.bcpStatus',
    header: 'Strategy Status',
    type: 'text',
    placeholder: 'Not Started',
  },
  {
    key: 'strategy.required',
    header: 'Strategy Required',
    type: 'boolean',
  },
];
